import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Message } from '../../../subcomponents/message/message';
import { SwapSeatUnavailableReason } from '../../../utils/swap-seats-utils';
const b = bemClassBuilder('v-swap-seat-picker-message');
export const SwapSeatPickerMessage = observer(props => {
    const { unavailableReason, displayText, assets } = props;
    return _jsx(Message, Object.assign({}, getMessageProps(unavailableReason, displayText, assets), { className: b.block() }));
});
SwapSeatPickerMessage.displayName = 'SwapSeatPickerMessage';
export const getMessageProps = (unavailableReason, displayText, assets) => {
    switch (unavailableReason) {
        case SwapSeatUnavailableReason.FailedToLoadData:
            return {
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage,
                iconName: assets.swapSeatsUnavailableIconName
            };
        case SwapSeatUnavailableReason.ShowtimeSoldOut:
            return {
                title: displayText.errorShowtimeSoldOutTitle,
                description: displayText.errorShowtimeSoldOutMessage,
                iconName: assets.swapSeatsUnavailableIconName
            };
        case SwapSeatUnavailableReason.ShowtimeEnded:
            return {
                title: displayText.errorShowtimeEndedTitle,
                description: displayText.errorShowtimeEndedMessage,
                iconName: assets.swapSeatsUnavailableIconName
            };
        case SwapSeatUnavailableReason.OrderIncludesPackageTickets:
            return {
                title: displayText.errorOrderIncludesPackageTicketsTitle,
                description: displayText.errorOrderIncludesPackageTicketsMessage,
                iconName: assets.swapSeatsUnavailableIconName
            };
        case SwapSeatUnavailableReason.OrderIncludesInSeatDeliveryItems:
            return {
                title: displayText.errorOrderIncludesInSeatDeliveryItemsTitle,
                description: displayText.errorOrderIncludesInSeatDeliveryItemsMessage,
                iconName: assets.swapSeatsUnavailableIconName
            };
        default:
            return {
                title: displayText.errorFailedToSwapSeatsTitle,
                description: displayText.errorFailedToSwapSeatsMessage,
                iconName: assets.failedToLoadDataIconName
            };
    }
};
